export type NoteGenerationErrorProps = {
  title: string;
  description: string;
};

const NoteGenerationError = ({
  title,
  description,
}: NoteGenerationErrorProps) => {
  return (
    <div className="vai-grid vai-w-full vai-items-start vai-gap-4 vai-mt-8">
      <div className="vai-p-4 vai-rounded-md vai-bg-red-700 vai-flex vai-flex-col vai-gap-1">
        <p className="vai-font-inter vai-font-semibold vai-text-sm vai-text-zinc-50">
          {title}
        </p>
        <p className="vai-font-inter vai-text-sm vai-text-[rgba(250,250,250,0.8)]">
          {description}
        </p>
      </div>
    </div>
  );
};

export default NoteGenerationError;
